<template>
  <Modal title="确认收货" :loading="true" v-model="modalVisible" :mask-closable="false">
    <Form class="sm" ref="form" :model="form" :rules="rules">
      <FormItem prop="fileId">
        <sl-upload-file :action="action" :display-file="true" v-model="form.fileId">
          <Button icon="ios-cloud-upload-outline">上传收货凭据</Button>
        </sl-upload-file>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      modalVisible:false,
      action:null,
      rules: {
        fileId: [
          { required:true , type:'number', message: '必须上传收货凭证', trigger: 'change' },
        ],
      },
      form: {
        id: '',
        fileId: null
      },
      loading:false
    }
  },

  created(){
    this.action = this.$request.orderFileUploadUrl()
  },
  mounted() {},

  methods: {
    init(id) {
      this.form.id = id
      this.form.fileId = null

      if(id){
        this.modalVisible = true
      }
    },

    save() {
      //
      let params = { ...this.form }

      this.loading = true
      this.$request.orderReceive(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('操作成功')
          this.$emit('on-update')
          this.modalVisible = false
          // this.$keepAlive.update()
        }
        this.loading = false
      })

    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleChange(v){
      console.log(v , this.form)
    }
  }
}
</script>